import { render } from "./SectionHead.vue?vue&type=template&id=1fb73774&scoped=true"
import script from "./SectionHead.vue?vue&type=script&lang=js"
export * from "./SectionHead.vue?vue&type=script&lang=js"

import "./SectionHead.vue?vue&type=style&index=0&id=1fb73774&lang=scss&scoped=true"

import exportComponent from "E:\\myProjects\\myPortfolio\\my-portfolio-vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb73774"]])

export default __exports__